import { useOutletContext } from 'react-router-dom'
import { GridSelectionModel } from '@/global/components/DataGrid/utils/types'
import { type PagamentoHoras, SaldoHoras } from 'service/api'

export function usePagamentoHorasOutletContext() {
    return useOutletContext<{
        data?: {
            pagamento: PagamentoHoras
            limite: Partial<SaldoHoras>
            saldo: SaldoHoras
        }[]
        competencia?: string
        selecionados?: GridSelectionModel
    }>()
}
